import { NameDto } from 'api/Common/Types'

export interface ClientDto {
  id: string
  clientAreaId: string
  name: string
  type: {
    id: number
    name: string
  }
  tickmillCompany: {
    id: number
    shortName: string
    name: string
  }
  status: {
    id: number
    name: string
  }
  country: {
    id: string
    name: string
  }
  emailAddress: string
  birthday: string
  phone: string
  username: string
  communicationLanguage: {
    id: string
    name: string
  }
  clientAmlSummary: null | {
    score: number
    AmlRiskLevel: NameDto
  }
  assignee: string | null
  isInternalTestAccount: boolean
  createdDate: string
  isSwapFreeAccount: boolean
  updatedDate: string
  selected: boolean
  introducingBroker: null | NameDto
}

export enum ClientDtoKey {
  id = 'id',
  name = 'name',
  type = 'type.name',
  status = 'status.name',
  country = 'country.name',
  emailAddress = 'emailAddress',
  username = 'username',
  phone = 'phone',
  assignee = 'assignee.name',
  tickmillCompany = 'tickmillCompany.name',
  tickmillCompanyShort = 'tickmillCompany.shortName',
  birthday = 'birthday',
  communicationLanguage = 'communicationLanguage',
  validationFinished = 'validationFinished',
  isSwapFreeAccount = 'isSwapFreeAccount',
  createdDate = 'createdDate',
  updatedDate = 'updatedDate',
  introducingBroker = 'introducingBroker.name',
}

export enum ClientFilterKey {
  name = 'Details.Name',
  type = 'Type',
  status = 'StatusId',
  country = 'Country',
  emailAddress = 'EmailAddress',
  username = 'UserName',
  phone = 'Details.PrimaryPhone',
  assignee = 'Assignee',
  tickmillCompany = 'TickmillCompanyName',
  tickmillCompanyShort = 'TickmillCompanyShortName',
  birthday = 'Birthday',
  introducingBroker = 'IB',
  vulnerableGroup = 'VulnerableGroupId',
  createdDate = 'Created',
  updatedDate = 'Updated',
}
